export const isAdminOnly = (roles) => {
  return roles?.includes("admin") && !roles?.includes("coach") && !roles?.includes("player");
};

export const isCoachOnly = (roles) => {
  return roles?.includes("coach") && !roles?.includes("admin") && !roles?.includes("player");
};

export const isPlayerOnly = (roles) => {
  return roles?.includes("player") && !roles?.includes("coach") && !roles?.includes("admin");
};

export const isDualRole = (roles) => {
  return roles?.includes("coach") && roles?.includes("admin");
};

export const isCoachOrAdmin = (roles) => {
  return roles?.includes("coach") || roles?.includes("admin");
};
